// extracted by mini-css-extract-plugin
module.exports = {"manutencao":"Manutencao_manutencao__qJjoq","spiner":"Manutencao_spiner__clLQZ"};